// // src/components/CareJourney/Heightweightscreen.jsx
// import { useState } from "react";
// import StepperProgress from "../Reusablesteps/Stepperprogress";
// import { BtnBack, BtnContinue } from "../Reusablecomponents/Button/Reusableutton";
// import { toFtIn } from "../Shared/CommonProfileScreen";
// // ── Global height/weight constants ─────────────────────────────────────────
// export const HEIGHT_MIN_IN = 48;   // 4'0"  — shortest clinically relevant adult
// export const HEIGHT_MAX_IN = 84;   // 7'0"  — tallest practical upper bound
// export const WEIGHT_MIN_KG = 20;   // extreme underweight floor
// export const WEIGHT_MAX_KG = 150;
// export const HEIGHT_DEFAULT_IN = 64;  // 5'4" — average adult height
// export const WEIGHT_DEFAULT_KG = 70;
// const T = {
//   purple700:   "var(--primary-color)",
//   purpleBtn:   "var(--secondary-color)",
//   purpleLight: "var(--ava-bg-primary-light)",
//   heading:     "#1A1033",
//   sub:         "#6B7280",
//   muted:       "#9CA3AF",
//   border:      "#E5E7EB",
//   green:       "#10B981",
//   amber:       "#F59E0B",
//   red:         "#EF4444",
// };

// const PageWrap = ({ children }) => (
//   <div style={{
//     minHeight: "100vh",
//     background: "linear-gradient(135deg,#e8f4f8 0%,#f0eeff 50%,#e8f4f8 100%)",
//     display: "flex", alignItems: "flex-start", justifyContent: "center",
//     padding: "48px 16px 24px", fontFamily: "system-ui, -apple-system, sans-serif",
//     boxSizing: "border-box",
//   }}>
//     <div style={{
//       width: "100%", maxWidth: 960, background: "white", borderRadius: 20,
//       padding: "24px 32px 20px", boxShadow: "0 4px 40px rgba(61,26,138,0.09)",
//       border: `1px solid ${T.border}`, boxSizing: "border-box",
//     }}>
//       {children}
//     </div>
//   </div>
// );

// export const RightCard = ({ children }) => (
//   <div style={{
//     background: "#fff", borderRadius: 14, padding: 14, border: `1px solid ${T.border}`,
//     display: "flex", flexDirection: "column", gap: 10,
//   }}>
//     {children}
//   </div>
// );

// // const BtnBack = ({ onClick }) => (
// //   <button onClick={onClick} style={{
// //     display: "flex", alignItems: "center", gap: 5, padding: "7px 14px",
// //     borderRadius: 8, fontSize: 12, fontWeight: 600,
// //     border: `1.5px solid ${T.border}`, background: "#fff", color: "#374151", cursor: "pointer",
// //   }}>
// //     ← Back
// //   </button>
// // );

// // const BtnContinue = ({ onClick, label = "Continue →" }) => (
// //   <button onClick={onClick} style={{
// //     display: "flex", alignItems: "center", gap: 8,
// //     padding: "8px 18px", borderRadius: 8, fontSize: 12, fontWeight: 600,
// //     color: "#fff", border: "none", background: T.purpleBtn,
// //     cursor: "pointer", minWidth: 140, justifyContent: "center",
// //   }}>
// //     {label}
// //   </button>
// // );

// const FooterBar = ({ left, center, right }) => (
//   <div style={{
//     display: "flex", alignItems: "center", justifyContent: "space-between",
//     padding: "12px 0 0", marginTop: 10, borderTop: `1px solid ${T.border}`,
//   }}>
//     <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>{left}</div>
//     <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>{center}</div>
//     <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>{right}</div>
//   </div>
// );

// const SliderRow = ({ label, value, min, max, onChange, display }) => (
//   <div style={{ marginBottom: 14 }}>
//     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
//       <label style={{ fontSize: 11, fontWeight: 700, color: T.heading }}>{label}</label>
//       <span style={{ fontSize: 13, fontWeight: 700, color: T.purple700 }}>{display}</span>
//     </div>
//     <input
//       type="range" min={min} max={max} value={value}
//       onChange={e => onChange(Number(e.target.value))}
//       style={{ width: "100%", accentColor: T.purple700, height: 4 }}
//     />
//     <div style={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}>
//       <span style={{ fontSize: 10, color: T.muted }}>{min}</span>
//       <span style={{ fontSize: 10, color: T.muted }}>{max}</span>
//     </div>
//   </div>
// );

// export function getBmiInfo(bmi) {
//   const n = parseFloat(bmi);
//   if (n < 18.5) return { label: "Underweight", color: T.amber };
//   if (n < 25)   return { label: "Normal",      color: T.green };
//   if (n < 30)   return { label: "Overweight",  color: T.amber };
//   return               { label: "Obese",       color: T.red };
// }

// const BMI_RANGES = [
//   { label: "Underweight", range: "< 18.5",      color: T.amber },
//   { label: "Normal",      range: "18.5 – 24.9", color: T.green },
//   { label: "Overweight",  range: "25 – 29.9",   color: T.amber },
//   { label: "Obese",       range: "≥ 30",         color: T.red   },
// ];

// export default function HeightWeightScreen({ onNext, onBack, initialValues = {},stepIndex ,totalSteps}) {
//   const [heightIn, setHeightIn] = useState(initialValues.heightIn ?? HEIGHT_DEFAULT_IN);
//   const [weightKg, setWeightKg] = useState(initialValues.weightKg ?? WEIGHT_DEFAULT_KG);

//   const ft   = Math.floor(heightIn / 12);
//   const in_  = heightIn % 12;
//   const bmi  = (weightKg / ((heightIn * 0.0254) ** 2)).toFixed(1);
//   const { label: bmiLabel, color: bmiColor } = getBmiInfo(bmi);

//   const handleSave = () => {
//     const data = { heightIn, weightKg, bmi: parseFloat(bmi) };
//     try {
//       const existing = JSON.parse(localStorage.getItem("patientPersona") || "{}");
//       localStorage.setItem("patientPersona", JSON.stringify({ ...existing, ...data, savedAt: Date.now() }));
//     } catch (_) {}
//     onNext(data);
//   };

//   return (
//     <>
//     {/* <PageWrap> */}
//       <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 12 }}>
//         <div>
//           <h1 style={{ fontSize: 20, fontWeight: 700, color: T.heading, marginBottom: 4 }}>Height & Weight</h1>
//           <p style={{ fontSize: 11, color: T.sub, margin: 0 }}>Used to calculate your BMI and personalize recommendations.</p>
//         </div>
//         {totalSteps?
//          <StepperProgress current={stepIndex} total={totalSteps} />
//          :""
//         }
//         {/* <div style={{ fontSize: 60, marginTop: -8, flexShrink: 0, userSelect: "none" }}>⚖️</div> */}
//       </div>

//       <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
//         <div style={{ flex: 1 }}>
//           <div style={{ background: "#fff", borderRadius: 12, padding: 16, border: `1px solid ${T.border}` }}>
//             <SliderRow
//               label="Height" value={heightIn} min={toFtIn(HEIGHT_MIN_IN)} max={toFtIn(HEIGHT_MAX_IN)}
//               onChange={setHeightIn}
//               display={`${ft}.${in_ === 0 ? "0" : in_} Ft`}
//             />
//             <SliderRow
//               label="Weight" value={weightKg} min={WEIGHT_MIN_KG} max={WEIGHT_MAX_KG}
//               onChange={setWeightKg}
//               display={`${weightKg} Kg`}
//             />
//             <div style={{
//               background: "#F9FAFB", border: `1.5px solid ${T.border}`, borderRadius: 10,
//               padding: 12, display: "flex", justifyContent: "space-between", alignItems: "center",
//             }}>
//               <div>
//                 <p style={{ fontSize: 10, color: T.muted, marginBottom: 4 }}>Your BMI</p>
//                 <p style={{ fontSize: 32, fontWeight: 700, color: bmiColor, margin: 0 }}>{bmi}</p>
//               </div>
//               <div style={{ textAlign: "right" }}>
//                 <span style={{ padding: "4px 12px", borderRadius: 99, fontSize: 11, fontWeight: 600, background: bmiColor + "22", color: bmiColor }}>
//                   {bmiLabel}
//                 </span>
//                 <p style={{ fontSize: 10, color: T.muted, margin: "6px 0 0" }}>Based on WHO standards</p>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div style={{ width: 220, flexShrink: 0 }}>
//           <RightCard>
//             <p style={{ fontWeight: 700, fontSize: 12, color: T.heading }}>Why BMI matters</p>
//             <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0 }}>
//               BMI is a useful screening tool, but just one part of the picture. We combine it with your life stage and symptoms for a holistic view.
//             </p>
//             {BMI_RANGES.map(b => (
//               <div key={b.label} style={{
//                 display: "flex", justifyContent: "space-between", alignItems: "center",
//                 padding: "5px 10px", borderRadius: 6,
//                 background: b.label === bmiLabel ? b.color + "20" : "transparent",
//               }}>
//                 <span style={{ fontSize: 10, fontWeight: b.label === bmiLabel ? 700 : 400, color: b.label === bmiLabel ? b.color : T.sub }}>
//                   {b.label}
//                 </span>
//                 <span style={{ fontSize: 10, color: T.muted }}>{b.range}</span>
//               </div>
//             ))}
//           </RightCard>
//         </div>
//       </div>

//       {/* <FooterBar
//         left={<BtnBack onClick={onBack} />}
//         center={null}
//         right={<BtnContinue onClick={handleSave} label="Save & Continue →" />}
//       /> */}
//       {/* <BtnBack variant="outline" onClick={onBack}/> */}
//       <FooterBar
//         left={ <BtnBack variant="outline" onClick={onBack}/>}
//         center={null}
//         right={<BtnContinue variant="primary" onClick={handleSave} label="Save & Continue"/>}
//       />
//     {/* </PageWrap> */}
//     </>
//   );
// }


import { useState } from "react";
import StepperProgress from "../Reusablesteps/Stepperprogress";
import { BtnBack, BtnContinue } from "../Reusablecomponents/Button/Reusableutton";
// import { HEIGHT_DEFAULT_IN, HEIGHT_MAX_IN, HEIGHT_MIN_IN, WEIGHT_DEFAULT_KG, WEIGHT_MAX_KG, WEIGHT_MIN_KG } from "../../config/constants";
// import 
import { toFtIn } from "../../pages/CareNavigator";
import { ScreenHeaderDFO } from "../HealthAssessment/SharedUI";
// import content from "./CareJourney.json";
import { useCareJourneyContent } from "../../hooks/useCareJourneyContent";
import { HEIGHT_DEFAULT_IN, HEIGHT_MAX_IN, HEIGHT_MIN_IN, WEIGHT_DEFAULT_KG, WEIGHT_MAX_KG, WEIGHT_MIN_KG} from "../../config/constants";

const T = {
  purple700:   "#3B1A8C",
  purpleBtn:   "#3D1A8A",
  purpleLight: "#EDE9FB",
  heading:     "#1A1033",
  sub:         "#6B7280",
  muted:       "#9CA3AF",
  border:      "#E5E7EB",
  green:       "#10B981",
  amber:       "#F59E0B",
  red:         "#EF4444",
}; 

export const RightCard = ({ children }) => (
  <div style={{
    background: "#fff", borderRadius: 14, padding: 14, border: `1px solid ${T.border}`,
    display: "flex", flexDirection: "column", gap: 10,
  }}>
    {children}
  </div>
);

const FooterBar = ({ left, center, right }) => (
  <div style={{
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "12px 0 0", marginTop: 10, borderTop: `1px solid ${T.border}`,
  }}>
    <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>{left}</div>
    <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>{center}</div>
    <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>{right}</div>
  </div>
);

const SliderRow = ({ label, value, min, max, onChange, display }) => (
  <div style={{ marginBottom: 14 }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
      <label style={{ fontSize: 11, fontWeight: 700, color: T.heading }}>{label}</label>
      <span style={{ fontSize: 13, fontWeight: 700, color: T.purple700 }}>{display}</span>
    </div>
    <input
      type="range" min={min} max={max} value={value}
      onChange={e => onChange(Number(e.target.value))}
      style={{ width: "100%", accentColor: T.purple700, height: 4 }}
    />
    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}>
      <span style={{ fontSize: 10, color: T.muted }}>{min}</span>
      <span style={{ fontSize: 10, color: T.muted }}>{max}</span>
    </div>
  </div>
);

export function getBmiInfo(bmi) {
  const n = parseFloat(bmi);
  if (n < 18.5) return { label: "Underweight", color: T.amber };
  if (n < 25)   return { label: "Normal",      color: T.green };
  if (n < 30)   return { label: "Overweight",  color: T.amber };
  return               { label: "Obese",       color: T.red };
}

const BMI_COLORS = {
  Underweight: T.amber,
  Normal: T.green,
  Overweight: T.amber,
  Obese: T.red,
};

export default function HeightWeightScreen({ onNext, onBack, initialValues = {}, stepIndex, totalSteps }) {
  const {content, loading,error}=useCareJourneyContent();
  const S = content?.screens?.heightWeight;
  const [heightIn, setHeightIn] = useState(initialValues.heightIn ?? HEIGHT_DEFAULT_IN);
  const [weightKg, setWeightKg] = useState(initialValues.weightKg ?? WEIGHT_DEFAULT_KG);
  if (!S) {
    console.error("heightWeight config missing from CareJourney.json");
    return null;
  }

  const ft   = Math.floor(heightIn / 12);
  const in_  = heightIn % 12;
  const bmi  = (weightKg / ((heightIn * 0.0254) ** 2)).toFixed(1);
  const { label: bmiLabel, color: bmiColor } = getBmiInfo(bmi);

  const handleSave = () => {
    const data = { heightIn, weightKg, bmi: parseFloat(bmi) };
    try {
      const existing = JSON.parse(localStorage.getItem("patientPersona") || "{}");
      localStorage.setItem("patientPersona", JSON.stringify({ ...existing, ...data, savedAt: Date.now() }));
    } catch (_) {}
    onNext(data);
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 12,flexWrap:"wrap" }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: T.heading, marginBottom: 4 }}>{S.pageTitle}</h1>
          <p style={{ fontSize: 11, color: T.sub, margin: 0 }}>{S.pageSubtitle}</p>
        </div>
        {totalSteps ? <StepperProgress current={stepIndex} total={totalSteps} /> : ""}
      </div>

      <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
        <div 
        // style={{ flex: 1 }}
        className="flex-none md:flex-1"
        >
          <div style={{ background: "#fff", borderRadius: 12, padding: 16, border: `1px solid ${T.border}` }}>
            <SliderRow
              label={S.labels.height} value={heightIn} min={HEIGHT_MIN_IN} max={HEIGHT_MAX_IN}
              onChange={setHeightIn}
              display={`${ft}.${in_ === 0 ? "0" : in_} ${S.units.heightUnit}`}
            />
            <SliderRow
              label={S.labels.weight} value={weightKg} min={WEIGHT_MIN_KG} max={WEIGHT_MAX_KG}
              onChange={setWeightKg}
              display={`${weightKg} ${S.units.weightUnit}`}
            />
            <div style={{
              background: "#F9FAFB", border: `1.5px solid ${T.border}`, borderRadius: 10,
              padding: 12, display: "flex", justifyContent: "space-between", alignItems: "center",
            }}>
              <div>
                <p style={{ fontSize: 10, color: T.muted, marginBottom: 4 }}>{S.labels.bmiLabel}</p>
                <p style={{ fontSize: 32, fontWeight: 700, color: bmiColor, margin: 0 }}>{bmi}</p>
              </div>
              <div style={{ textAlign: "right" }}>
                <span style={{ padding: "4px 12px", borderRadius: 99, fontSize: 11, fontWeight: 600, background: bmiColor + "22", color: bmiColor }}>
                  {bmiLabel}
                </span>
                <p style={{ fontSize: 10, color: T.muted, margin: "6px 0 0" }}>{S.labels.bmiSource}</p>
              </div>
            </div>
          </div>
        </div>

        <div style={{ width: 220, flexShrink: 0 }}>
          <RightCard>
            <p style={{ fontWeight: 700, fontSize: 12, color: T.heading }}>{S.sideCard.title}</p>
            <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0 }}>
              {S.sideCard.description}
            </p>
            {S.bmiCategories.map(b => (
              <div key={b.label} style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "5px 10px", borderRadius: 6,
                background: b.label === bmiLabel ? BMI_COLORS[b.label] + "20" : "transparent",
              }}>
                <span style={{ fontSize: 10, fontWeight: b.label === bmiLabel ? 700 : 400, color: b.label === bmiLabel ? BMI_COLORS[b.label] : T.sub }}>
                  {b.label}
                </span>
                <span style={{ fontSize: 10, color: T.muted }}>{b.range}</span>
              </div>
            ))}
          </RightCard>
        </div>
      </div>

      <FooterBar
        left={<BtnBack variant="outline" onClick={onBack} />}
        center={null}
        right={<BtnContinue variant="primary" onClick={handleSave} label={S.buttons.continue.label} />}
      />
    </>
  );
}
